import React, { useEffect, useState } from "react";
import Web3 from "web3";
import token from "./Token";
import { useSelector } from "react-redux";
import { connect } from "../store/actions/connected";
import { wallet } from "../store/actions/wallet";
import { chain } from "../store/actions/chain";
import { useDispatch } from "react-redux";
import Alert from "./small/Alert";
import { metamask } from "../store/actions/metamask";
import { waitForReceipt, getChain } from "./functions";
import Txprocessing from "./small/Txprocessing";
import Txsuccess from "./small/Txsuccess";
import Form from "react-bootstrap/Form";
import { info } from "../info";
import Input from "./small/Input";
import Switch from "./small/Switch";
import ButtonCustom from "./small/ButtonCustom";
import Range from "./small/Range";
import axios from "axios";

function Home({ testMode }) {
  const dispatch = useDispatch();
  const connection = useSelector((state) => state.connect);
  const connectedAddress = useSelector((state) => state.wallet[0]);
  const isMetamask = useSelector((state) => state.metamask);

  const [walletAddress, setWalletAddress] = useState(null);
  useEffect(() => {
    const getSiteContent = async () => {
      try {
        const res = await axios.get(info.apiUrl + "items/fee_wallet");
        setWalletAddress(res.data.data.address);
      } catch (error) {
        console.log(error);
      }
    };
    getSiteContent();
  }, []);

  async function connectWeb3() {
    try {
      if (window.ethereum) {
        const provider = window.ethereum;
        const web3 = new Web3(provider);
        const accounts = await provider.request({
          method: "eth_requestAccounts",
        });
        const account = accounts[0];
        console.log(web3);
        const cha = web3.currentProvider.networkVersion;
        dispatch(chain(getChain(cha)));
        dispatch(wallet(account));
        dispatch(connect());
        provider.on("chainChanged", (_chainId) => window.location.reload());
      } else {
        dispatch(metamask());
      }
    } catch (error) {
      console.log(error);
    }
  }

  const [screen, setScreen] = useState("first");

  const initialToken = token[0];

  const [tokenTypeFront, setTokenTypeFront] = useState(initialToken);

  const [serviceFee, setServiceFee] = useState("");

  const [txError, setTxError] = useState(false);

  const [errorMsg, setErrorMsg] = useState("");

  const [txHappening, setTxHappening] = useState(false);

  const [txMessage, setTxMessage] = useState("");

  const [txSuccess, setTxSuccess] = useState(false);

  const [txSuccessMessage, setTxSuccessMessage] = useState("");

  const [networkExplorer, setNetworkExplorer] = useState("");

  const [chosenNetwork, setChosenNetwork] = useState("");

  const [args, setArgs] = useState([]);

  const [networkCurrency, setNetworkCurrency] = useState("");

  //token bilgi state leri

  //token name
  const [tokenName, setTokenName] = useState("");

  //token symbol
  const [tokenSymbol, setTokenSymbol] = useState("");

  //token initial supply
  const [tokenInitialSupply, setTokenInitialSupply] = useState("");

  //token decimals
  const [tokenDecimals, setTokenDecimals] = useState("");

  //burnable buton kontrol
  const [isBurnable, setIsBurnable] = useState(false);
  const handleBurnableClick = () => {
    setIsBurnable(!isBurnable);
    console.log(isBurnable);
  };

  //mintable buton kontrol
  const [isMintable, setIsMintable] = useState(false);
  const handleMintableableClick = () => {
    setIsMintable(!isMintable);
  };

  //fee işlemleri
  //fee butonu kontrol
  const [feechecked, setFeechecked] = useState(false);

  const handlefeeClick = () => {
    setFeechecked(!feechecked);
  };

  //burn değeri
  const [burnvalue, setBurnvalue] = useState(5);

  //tax değeri
  const [taxvalue, setTaxvalue] = useState(5);

  //tax receiving address
  const [taxAddress, setTaxAddress] = useState("");
  //

  //redistribution işlemleri
  //redistribution kontrol
  const [redchecked, setRedchecked] = useState(false);

  const handleredClick = () => {
    setRedchecked(!redchecked);
  };

  //redistribution değeri
  const [redistributionvalue, setRedistributionvalue] = useState(5);

  useEffect(() => {
    tokenType();
  }, [isBurnable, isMintable, feechecked, redchecked]);

  useEffect(() => {
    setFrontNetwork();
  }, [screen, tokenTypeFront]);

  useEffect(() => {
    prepareArguments();
  }, [
    tokenInitialSupply,
    tokenName,
    tokenSymbol,
    tokenDecimals,
    tokenTypeFront,
    taxAddress,
  ]);

  function tokenType() {
    const ttype = [isBurnable, isMintable, feechecked, redchecked];

    token.forEach((a) => {
      if (
        a.tokenType[0] === ttype[0] &&
        a.tokenType[1] === ttype[1] &&
        a.tokenType[2] === ttype[2] &&
        a.tokenType[3] === ttype[3]
      ) {
        console.log(a);
        setTokenTypeFront(a);
      }
    });
  }

  function setFrontNetwork() {
    if (screen === "Bep-20") {
      setChosenNetwork("Binance Smart Chain");
      setServiceFee(tokenTypeFront.priceShare.bnbPrice);
      setNetworkCurrency("BNB");
      setNetworkExplorer("https://bscscan.com/");
    } else if (screen === "Erc-20") {
      setChosenNetwork("Ethereum Mainnet");
      setServiceFee(tokenTypeFront.priceShare.ethPrice);
      setNetworkCurrency("ETH");
      setNetworkExplorer("https://etherscan.com/");
    } else if (screen === "Frc-20") {
      setChosenNetwork("Fantom Mainnet");
      setServiceFee(tokenTypeFront.priceShare.ftmPrice);
      setNetworkCurrency("FTM");
      setNetworkExplorer("https://ftmscan.com/");
    } else if (screen === "Mrc-20") {
      setChosenNetwork("Polygon Mainnet");
      setServiceFee(tokenTypeFront.priceShare.maticPrice);
      setNetworkCurrency("MATIC");
      setNetworkExplorer("https://polygonscan.com/");
    }
  }

  function prepareArguments() {
    if (
      tokenTypeFront.tokenType[2] === false &&
      tokenTypeFront.tokenType[3] === false
    ) {
      setArgs([
        tokenInitialSupply,
        tokenName,
        tokenSymbol,
        tokenDecimals,
        walletAddress,
      ]);
    } else if (
      tokenTypeFront.tokenType[2] === true &&
      tokenTypeFront.tokenType[3] === false
    ) {
      setArgs([
        tokenInitialSupply,
        tokenName,
        tokenSymbol,
        tokenDecimals,
        burnvalue,
        taxvalue,
        taxAddress,
        walletAddress,
      ]);
    } else if (
      tokenTypeFront.tokenType[2] === false &&
      tokenTypeFront.tokenType[3] === true
    ) {
      setArgs([
        tokenInitialSupply,
        tokenName,
        tokenSymbol,
        tokenDecimals,
        redistributionvalue,
        walletAddress,
      ]);
    } else if (
      tokenTypeFront.tokenType[2] === true &&
      tokenTypeFront.tokenType[3] === true
    ) {
      setArgs([
        tokenInitialSupply,
        tokenName,
        tokenSymbol,
        tokenDecimals,
        burnvalue,
        taxvalue,
        redistributionvalue,
        taxAddress,
        walletAddress,
      ]);
    }
  }

  function correctNetwork() {
    const provider = window.ethereum;
    const web3 = new Web3(provider);
    const networkVer = web3.currentProvider.networkVersion;
    if (screen === "Bep-20" && networkVer == "56") {
      return true;
    } else if (screen === "Erc-20" && networkVer == "1") {
      return true;
    } else if (screen === "Frc-20" && networkVer == "250") {
      return true;
    } else if (screen === "Mrc-20" && networkVer == "137") {
      return true;
    } else {
      return false;
    }
  }

  async function deployToken() {
    if (!correctNetwork() && !testMode) {
      setTxError(true);
      setErrorMsg("Please connect to the correct network");
      setTimeout(() => {
        setTxError(false);
      }, 5000);
      return;
    }
    try {
      if (!tokenInitialSupply || !tokenName || !tokenSymbol || !tokenDecimals) {
        setTxError(true);
        setErrorMsg("Please fill all the required information.");
        setTimeout(() => {
          setTxError(false);
        }, 5000);
        return;
      } else if (
        !Number(tokenInitialSupply) > 0 ||
        !Number(tokenDecimals) > 0
      ) {
        setTxError(true);
        setErrorMsg("Token initial supply and decimals should be numbers");
        setTimeout(() => {
          setTxError(false);
        }, 5000);
        return;
      } else if (feechecked) {
        if (
          taxAddress.length !== 42 &&
          taxAddress[0] !== "0" &&
          taxAddress[1] !== "x"
        ) {
          setTxError(true);
          setErrorMsg("Tax receiever address must be filled");
          setTimeout(() => {
            setTxError(false);
          }, 5000);
          return;
        }
      }
      console.log(Number(tokenInitialSupply), Number(tokenDecimals));
      const provider = window.ethereum;
      const web3 = new Web3(provider);

      async function wallet_watchAsset(tokenAddress, symbol, decimals) {
        const wasAdded = await provider.request({
          method: "wallet_watchAsset",
          params: {
            type: "ERC20",
            options: {
              address: tokenAddress,
              symbol: symbol,
              decimals: decimals,
            },
          },
        });
      }

      const commission = web3.utils.toWei(String(serviceFee));

      const accounts = await provider.request({
        method: "eth_requestAccounts",
      });
      console.log(tokenTypeFront, "token");
      const gascontract = new web3.eth.Contract(tokenTypeFront.tokenAbi);
      const options = {
        data: tokenTypeFront.tokenByte,
        arguments: args,
      };

      const estimatedGas = await gascontract.deploy(options).estimateGas({
        from: accounts[0],
        value: commission,
        gas: "10000000",
      });

      const contract = await new web3.eth.Contract(tokenTypeFront.tokenAbi)
        .deploy(options)
        .send(
          {
            from: accounts[0],
            value: commission,
            gas: estimatedGas,
            //gasPrice: '1000000000'
          },
          function (error, transactionHash) {
            if (error) {
              setTxError(true);
              setErrorMsg(error.message);
              setTimeout(() => {
                setTxError(false);
              }, 5000);
            } else if (transactionHash) {
              function txDone(receipt) {
                if (receipt.status) {
                  setTxHappening(false);
                  setTxSuccess(true);
                  setTimeout(() => {
                    setTxSuccess(false);
                  }, 2000);
                } else {
                  setTxHappening(false);
                  setTxError(true);
                  setErrorMsg("Error : Transaction reverted");
                  setTimeout(() => {
                    setTxError(false);
                  }, 5000);
                }
              }
              const txLink = networkExplorer + "tx/" + transactionHash;
              setTxHappening(true);
              setTxMessage(txLink);
              waitForReceipt(transactionHash, txDone);
            }
          }
        );

      console.log("deployed to ", contract.options.address);
      const txSucMes = networkExplorer + "contract/" + contract.options.address;
      setTxSuccessMessage(txSucMes);
      wallet_watchAsset(contract.options.address, tokenSymbol, tokenDecimals);
    } catch (error) {
      var msg;
      if (error.code == -32000) {
        msg = "This account doesn't have enough funds.";
      } else {
        msg = error.message;
      }
      console.log(error);
      setTxError(true);
      setErrorMsg(msg);
      setTimeout(() => {
        setTxError(false);
      }, 5000);
    }
  }

  return (
    <>
      <div className="page_wrapper">
        <section className="contact_page_section mb-140">
          <div className="container">
            <div className="contact_info_area">
              <div className="row">
                <div
                  className="col-md-3 mt-3"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => setScreen("Erc-20")}
                >
                  <div
                    className="custom-card"
                    style={{
                      cursor: "pointer",
                      border: screen === "Erc-20" && "1px solid #822eda",
                    }}
                  >
                    <img
                      src="assets/pics/ethereum.png"
                      style={{ width: "100px" }}
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="col-md-3 mt-3"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => setScreen("Bep-20")}
                >
                  <div
                    className="custom-card"
                    style={{
                      cursor: "pointer",
                      border: screen === "Bep-20" && "1px solid #822eda",
                    }}
                  >
                    <img
                      src="assets/pics/binance-smart-chain.png"
                      style={{ width: "100px" }}
                      alt=""
                    />
                  </div>
                </div>
                <div
                  className="col-md-3 mt-3"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => setScreen("Frc-20")}
                >
                  <div
                    className="custom-card"
                    style={{
                      cursor: "pointer",
                      border: screen === "Frc-20" && "1px solid #822eda",
                    }}
                  >
                    <img
                      src="assets/pics/fantom_logo.png"
                      alt=""
                      style={{ width: "100px" }}
                    />
                  </div>
                </div>
                <div
                  className="col-md-3 mt-3"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={() => setScreen("Mrc-20")}
                >
                  <div
                    className="custom-card"
                    style={{
                      cursor: "pointer",
                      border: screen === "Mrc-20" && "1px solid #822eda",
                    }}
                  >
                    <img
                      src="assets/pics/polygon_logo.png"
                      alt=""
                      style={{ width: "100px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="contact_form_area">
              <div className="section_title text-center mb-60 mt-3">
                <p>
                  {screen === "first" &&
                    "Choose A Network To Create Your Token"}
                  {screen !== "first" && (
                    <>
                      You are about to create your token on {chosenNetwork}{" "}
                      creation fee is {serviceFee + " " + networkCurrency}
                    </>
                  )}
                </p>
              </div>
              {screen !== "first" && (
                <div className="contact_form_inner">
                  <form id="contact-form" action="assets/mail.php">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="custom-card">
                          <div className="row">
                            <div className="col-lg-6">
                              <Input
                                type="text"
                                onChange={(e) => setTokenName(e.target.value)}
                                placeholder="Token Name e.g. My Token"
                                id="tokenname"
                              />
                            </div>
                            <div className="col-lg-6">
                              <Input
                                type="text"
                                onChange={(e) => setTokenSymbol(e.target.value)}
                                placeholder="Token Symbol e.g. MT"
                                id="tokensymbol"
                              />
                            </div>
                            <div className="col-lg-6">
                              <Input
                                type="text"
                                onChange={(e) =>
                                  setTokenInitialSupply(e.target.value)
                                }
                                className="form-control"
                                placeholder="initial supply e.g. 18000000"
                                id="supply"
                              />
                            </div>
                            <div className="col-lg-6">
                              <Input
                                type="text"
                                onChange={(e) =>
                                  setTokenDecimals(e.target.value)
                                }
                                className="form-control"
                                placeholder="Decimals e.g. 18"
                                id="decimals"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6 text-center p-3">
                        <div className="p-2 mt-2 custom-card">
                          <h3>Burnable</h3>
                          <Switch
                            onChange={handleBurnableClick}
                            id="burnable"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 text-center mt-2 p-3">
                        <div className="p-2 custom-card">
                          <h3>Mintable</h3>
                          <Switch
                            onChange={handleMintableableClick}
                            id="mintable"
                          />
                        </div>
                      </div>

                      <div className="col-lg-12 text-center p-3">
                        {" "}
                        <div className="p-2 custom-card">
                          <h3>Fee / Tax</h3>
                          <Switch onChange={handlefeeClick} id="feetax" />
                          {feechecked && (
                            <>
                              <div>
                                <p className="switch mr-1">Burn Fee</p>
                                <Range onChange={setBurnvalue} />

                                {"%" + burnvalue}
                              </div>
                              <div>
                                <p className="switch mr-1">Tax Fee</p>

                                <Range onChange={setTaxvalue} />

                                <span className="white-text ml-2">
                                  {"%" + taxvalue}
                                </span>
                              </div>
                              <div className="form_input">
                                <p className="switch mr-1">
                                  Tax Receiving Address
                                </p>
                                <Input
                                  type="text"
                                  onChange={(e) =>
                                    setTaxAddress(e.target.value)
                                  }
                                  placeholder="initial supply e.g. 18000000"
                                  id="taxaddress"
                                />
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-12 text-center p-3">
                        <div className="p-2 custom-card">
                          <h3>Holder Redistribution</h3>
                          <Switch onChange={handleredClick} id="holder" />
                          {redchecked && (
                            <>
                              <p className="switch">Redistribution Fee</p>
                              <Range onChange={setRedistributionvalue} />
                              <span className="white-text ml-2">
                                {"%" + redistributionvalue}
                              </span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="form_input_btn text-center mt-5 mb-5">
                      <ButtonCustom
                        title={connection ? "Deploy" : "Connect"}
                        onClick={!connection ? connectWeb3 : deployToken}
                      />
                    </div>
                    <p className="form-message mt-3 mb-3" />
                  </form>
                </div>
              )}
            </div>
          </div>
        </section>

        {isMetamask === false ? (
          <Alert
            alertType={"alert-danger"}
            alertContent={`You need to install Metamask to use this app.`}
          />
        ) : null}
        {txHappening && <Txprocessing alertContent={txMessage} />}
        {txSuccess && <Txsuccess alertContent={txSuccessMessage} />}
        {txError === true ? (
          <Alert alertType={"alert-danger"} alertContent={errorMsg} />
        ) : null}
      </div>
    </>
  );
}

export default Home;
